import Head from 'next/head';
import type { GetServerSideProps, InferGetStaticPropsType } from 'next';
import { NextPageWithLayout } from '@/pages/_app';
import React from 'react';
import Layout from '../layouts';
import { AppSettings, lowerName } from '@/shared/app-common';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import FeedbackContent from '@/components/FeedbackContent';
import { canonicalUrl } from '@/shared/utils';

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { locale, req, resolvedUrl, defaultLocale } = context;

  const localeRes = await serverSideTranslations(locale, ['common']);
  // const currentURL = `https://${req.headers.host}${resolvedUrl}`;
  const tempData = localeRes['_nextI18Next']['initialI18nStore'][locale]['common'] ?? {};

  // const res = await fetchBabyPhotoItemsData(locale);

  return {
    props: {
      ...localeRes,
      herf: canonicalUrl(req.headers.host, resolvedUrl, locale),
      locale,
      title: tempData['head_Meta_Title'],
      description: tempData['head_Meta_Desc'],
    },
  };
};

const Home: NextPageWithLayout<InferGetStaticPropsType<typeof getServerSideProps>> = (props) => {
  return <FeedbackContent />;
};

Home.getLayout = function getLayout(page: React.ReactElement) {
  const title = page?.props?.title ?? '';
  const desc = page?.props?.description ?? '';

  return (
    <Layout
      head={
        <Head>
          <title>{title}</title>
          <meta name="title" content={title} />
          <meta name="description" content={desc} />

          <meta property="og:title" content={title} />
          <meta property="og:description" content={desc} />
          <meta property="og:image" content={AppSettings.logoUrl} />
          <meta property="og:image:secure_url" content={AppSettings.logoUrl} />
          <meta property="og:type" content="summary" />
          <meta property="og:url" content={page.props?.herf} />

          <meta name="twitter:title" content={title} />
          <meta name="twitter:description" content={desc} />
          <meta name="twitter:image" content={AppSettings.logoUrl} />
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:site" content={page.props?.herf} />

          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <link rel="canonical" href={page.props?.herf} />
        </Head>
      }
      showHeader={false}
    >
      {page}
    </Layout>
  );
};

export default Home;
